export const SUCCESS_GET_ALL_PRINTER_PROFILES = 'SUCCESS_GET_ALL_PRINTER_PROFILES';
export const FAILED_GET_ALL_PRINTER_PROFILES = 'FAILED_GET_ALL_PRINTER_PROFILES';
export const SUCCESS_GET_PRINTER_PROFILE = 'SUCCESS_GET_PRINTER_PROFILE';
export const FAILED_GET_PRINTER_PROFILE = 'FAILED_GET_PRINTER_PROFILE';
export const SUCCESS_CREATE_PRINTER_PROFILE = 'SUCCESS_CREATE_PRINTER_PROFILE';
export const FAILED_CREATE_PRINTER_PROFILE = 'FAILED_CREATE_PRINTER_PROFILE';
export const SUCCESS_UPDATE_PRINTER_PROFILE = 'SUCCESS_UPDATE_PRINTER_PROFILE';
export const FAILED_UPDATE_PRINTER_PROFILE = 'FAILED_UPDATE_PRINTER_PROFILE';
export const SUCCESS_DELETE_PRINTER_PROFILE = 'SUCCESS_DELETE_PRINTER_PROFILE';
export const FAILED_DELETE_PRINTER_PROFILE = 'FAILED_DELETE_PRINTER_PROFILE';



// WEBPACK FOOTER //
// src/state/constants/printerProfileConstants.js